module.exports = __webpack_public_path__ + "assets/dish_icon.2b9d7f37.svg";